/**
 * Parametrización de la ÚNICA composición Pixi (no es un feature flag ni doble path):
 * - Editor (default): 1920×1080 con `captureStream` activo (preview del operador).
 * - Broadcast OSR: 4K sin `captureStream` — el encode de broadcast es NVENC sobre la
 *   shared texture del OSR, que REEMPLAZA al path WebCodecs/captureStream.
 *
 * Se debe setear ANTES de bootear el pipeline: `PixiFactory`/`RenderFactory` leen estos
 * valores en su construcción.
 */
export interface CompositionConfig {
  width: number;
  height: number;
  /**
   * Si true, `PixiFactory` hace `canvas.captureStream(60)` (editor/preview). En el modo
   * broadcast OSR es false: la captura la hace NVENC sobre la shared texture del OSR.
   */
  captureStream: boolean;
}

export const compositionConfig: CompositionConfig = {
  width: 1920,
  height: 1080,
  captureStream: true,
};

export function configureComposition(
  partial: Partial<CompositionConfig>,
): void {
  Object.assign(compositionConfig, partial);
}
